import type { UserProfileData } from 'src/types/requests/services/user_profile_data';

export const normalizeProfileData = (profile: UserProfileData): UserProfileData => {
	const normalizedProfile = { ...profile };

	if (normalizedProfile.ar_campaigns !== undefined && !Array.isArray(normalizedProfile.ar_campaigns)) {
		normalizedProfile.ar_campaigns = Object.values(normalizedProfile.ar_campaigns);
	}

	return normalizedProfile;
};

export const getLegacyNewsletterPreference = (
	profile: UserProfileData,
	home: Record<string, any> | false,
) => {
	if (profile.showNewsletter !== undefined) return undefined;
	return profile.newsletterPrompt ?? (home && home.newsletterPrompt);
};

export const upsertProfileField = (
	profile: UserProfileData,
	id: string,
	data: unknown,
): UserProfileData => ({
	...profile,
	[id]: data,
});

export const deleteProfileField = (profile: UserProfileData, id: string): UserProfileData => {
	const nextProfile = { ...profile };
	delete nextProfile[id];
	return nextProfile;
};
